// The trip's scripts (WI-10): which decks are scripts to learn one character at a time, from the
// language kit (pack.meta.scripts: katakana and hiragana for Japanese, hangul for Korean, none for
// Italian). Pure and pack-agnostic: nothing here names a language's deck.
import type { Pack } from '../../shared/pack/schema'

/**
 * Katakana's and hiragana's basic rows (the 46 a kana chart starts with); dakuten, yōon, extended
 * and marks count as "extras". A script whose cards carry none of these tags is all basic.
 */
const BASIC_ROWS = ['a-row', 'ka-row', 'sa-row', 'ta-row', 'na-row', 'ha-row', 'ma-row', 'ya-row', 'ra-row', 'wa-row']

/** A deck of single characters: every card a reading of one or two glyphs (キャ counts). */
function isCharDeck(d: Pack['decks'][number]): boolean {
  return d.kind === 'script' && d.cards.every((c) => c.kind === 'reading' && [...c.script].length <= 2)
}

/**
 * The script decks in teaching order: the kit's list, or, for a pack built before packs carried
 * it, the script decks of single characters in deck order. Only decks the pack has.
 */
export function scriptDecks(pack: Pack): string[] {
  const ids = pack.meta.scripts ?? pack.decks.filter(isCharDeck).map((d) => d.id)
  return ids.filter((id) => pack.decks.some((d) => d.id === id))
}

/** A script deck's basic characters (all of them when the deck doesn't tag rows). */
export function basicIds(pack: Pack, deckId: string | undefined): string[] {
  const cards = pack.decks.find((d) => d.id === deckId)?.cards ?? []
  const basic = cards.filter((c) => c.tags.some((t) => BASIC_ROWS.includes(t)))
  return (basic.length ? basic : cards).map((c) => c.id)
}

/** The first script's basic characters (the 46 basic katakana for Japanese). */
export function basicKanaIds(pack: Pack): string[] {
  return basicIds(pack, scriptDecks(pack)[0])
}
